import { render, staticRenderFns } from "./Asientos.vue?vue&type=template&id=507f675d&scoped=true&"
import script from "./Asientos.vue?vue&type=script&lang=js&"
export * from "./Asientos.vue?vue&type=script&lang=js&"
import style0 from "./Asientos.vue?vue&type=style&index=0&id=507f675d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f675d",
  null
  
)

export default component.exports